import React from 'react';
import { useInViewOnce } from '../../hooks/useInViewOnce';

/**
 * ورود تدریجی هنگام اسکرول — بدون وابستگی خارجی.
 */
export default function Reveal({
  children,
  className = '',
  delayMs = 0,
  as: Tag = 'div',
  ...rest
}) {
  const [ref, inView] = useInViewOnce({ once: true });

  return (
    <Tag
      ref={ref}
      className={`transition-all duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] motion-reduce:transition-none motion-reduce:opacity-100 motion-reduce:translate-y-0 ${
        inView ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
      } ${className}`.trim()}
      style={{ transitionDelay: inView ? `${delayMs}ms` : undefined }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
